import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Internship from './components/Internship';
import Founders from './components/Founders';
import CoFounders from './components/CoFounders';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Internship />
      <Founders />
      <CoFounders />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;

